/**
 * Render a string with substring matches wrapped in <mark>
 * (P74.2). Used by SearchView result rows + TopnavSearch
 * dropdown rows to show "which letters did I type?".
 */
import { highlightMatches } from "shared/search/highlightMatches";

interface HighlightedTextProps {
  text: string | null | undefined;
  query: string | null | undefined;
}

export function HighlightedText({ text, query }: HighlightedTextProps) {
  const segments = highlightMatches(text, query);
  if (segments.length === 0) return null;
  return (
    <>
      {segments.map((seg, idx) =>
        seg.match ? (
          <mark key={idx} className="bg-amber-100 text-amber-900 rounded-sm px-0.5">
            {seg.text}
          </mark>
        ) : (
          <span key={idx}>{seg.text}</span>
        ),
      )}
    </>
  );
}
